/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import ProfileCardLink from '../../../../../components/core/ProfileCardLink/ProfileCardLink';
import TableCellEllipsis from '../../../../../components/core/TableCellEllipsis/TableCellEllipsis';
import { VehicleType } from '../../../../../models/core/vehicles.type';
import { formatTimestampToString } from '../../../../../utils/formatter.utils';
import DataViewActions from './DataViewActions';

type DataViewProps = {
  data: VehicleType[];
  confirmActionResult(item: VehicleType, action: string, confirmed: boolean): void;
};

export default function DataView(props: DataViewProps) {
  const columns: ColumnsType<any> = [
    {
      title: 'Veículo',
      key: 'residuoVeiculo',
      dataIndex: 'residuoVeiculo',
      sorter: (a: VehicleType, b: VehicleType) => a.residuoVeiculo.localeCompare(b.residuoVeiculo),
    },
    {
      title: 'Descrição',
      key: 'descricao',
      sorter: (a: VehicleType, b: VehicleType) => {
        return (a.descricao || '').localeCompare(b.descricao || '');
      },
      render: (row: VehicleType) => (
        <TableCellEllipsis label={row?.descricao} numberOfChars={25} toolTipWidth={300} />
      ),
    },
    {
      title: 'Criado Por',
      key: 'criadoPor',
      sorter: (a: VehicleType, b: VehicleType) => a.criadoPor.localeCompare(b.criadoPor),
      render: (row: VehicleType) => (
        <ProfileCardLink id={row.idCriadoPor} name={row.criadoPor} nameSize="sm" />
      ),
    },
    {
      title: 'Data Criação',
      key: 'dataCriacao',
      sorter: (a: VehicleType, b: VehicleType) =>
        new Date(a.dataCriacao).valueOf() - new Date(b.dataCriacao).valueOf(),
      render: (row: VehicleType) => formatTimestampToString(row.dataCriacao),
    },
    {
      title: 'Modificado Por',
      key: 'modificadoPor',
      sorter: (a: VehicleType, b: VehicleType) =>
        (a.modificadoPor || '').localeCompare(b.modificadoPor || ''),
      render: (row: VehicleType) => {
        if (row.idModificadoPor) {
          return (
            <ProfileCardLink id={row.idModificadoPor || ''} name={row.modificadoPor || ''} nameSize="sm" />
          );
        }
        return '-';
      },
    },
    {
      title: 'Data Modificação',
      key: 'dataModificacao',
      sorter: (a: VehicleType, b: VehicleType) => {
        const date = new Date();
        return new Date(a.dataModificacao || date).valueOf() - new Date(b.dataModificacao || date).valueOf();
      },
      render: (row: VehicleType) => {
        if (row.dataModificacao) {
          return formatTimestampToString(row.dataModificacao);
        }
        return '-';
      },
    },
    {
      title: 'Ações',
      width: '130px',
      render: (row: VehicleType) => (
        <DataViewActions item={row} confirmActionResult={props.confirmActionResult} />
      ),
    },
  ];

  return (
    <Table
      showSorterTooltip={false}
      dataSource={props.data}
      columns={columns}
      rowKey={(item: VehicleType) => item.idResiduoVeiculo}
      pagination={{
        pageSizeOptions: [10, 25, 50],
        showSizeChanger: true,
        showTotal: (total, range) => `${range[0]} - ${range[1]} de ${total} resultado(s)`,
      }}
    />
  );
}
